import script from "./AdminAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnnouncements.vue?vue&type=style&index=0&id=4e51bbaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e51bbaa"]])

export default __exports__